
import prefixes from '../../../languages/prefixes.json'

export default {
  name: 'FormGroup',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    datepicker: {
      type: Boolean,
      default: false
    },
    outsideLabel: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    fieldError: {
      type: String,
      default: ''
    },
    publicPath: {
      type: String,
      default: '/'
    },
    inputValue: {
      type: String,
      default: ''
    },
    disableAutocomplete: {
      type: Boolean,
      default: false
    },
    roundedBorder: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isCrossClean: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: ''
    },
    dataTestId: {
      type: String,
      default: 'form-group'
    },
    isAutofilled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    showCross: {
      type: Boolean,
      default: false
    },
    showCheck: {
      type: Boolean,
      default: false
    },
    languages: {
      type: Array,
      default: () => []
    },
    defaultLanguage: {
      type: Object,
      default: () => ({})
    },
    phoneNumber: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFocused: false,
      innerValue: null,
      type: this.inputType,
      suggestActive: false,
      isNotValidated: true,
      isOpen: false,
      selectedLanguage: this.getStartLanguage(),
      prefixes
    }
  },
  watch: {
    innerValue(newVal) {
      this.$emit('value', newVal)
    },
    inputValue(newVal) {
      this.innerValue = newVal
    }
  },
  mounted() {
    this.innerValue = this.inputValue
  },
  computed: {
    classes() {
      return {
        'form-control': true,
        'is-invalid':
          this.error ||
          this.fieldError !== '' ||
          (this.isCrossClean && !this.datepicker && this.isNotValidated && this.isRequired) ||
          (!this.inputValue && this.isCrossClean && !this.isRequired),
        'is-red': this.error || this.fieldError !== '',
        'rounded-border': this.roundedBorder,
        'outside-input': this.outsideLabel,
        'phone-number': this.phoneNumber
      }
    }
  },
  methods: {
    resetField() {
      this.innerValue = ''
      this.isFocused = false
      if (this.isCrossClean) {
        this.isNotValidated = true
        this.$nextTick(() => {
          this.$refs.myInput.focus()
        })
      }
      this.$emit('resetField')
    },
    getStartLanguage() {
      if (this.prefix) {
        for (const country of Object.values(prefixes)) {
          if (country.prefix === this.prefix) {
            return country
          }
        }
      } else return this.defaultLanguage
    },
    handleBlur(event) {
      if (this.isCrossClean && !this.datepicker) {
        this.isFocused = false
        this.isNotValidated = false
      }
      this.suggestActive = false
      this.$emit('validate', event)
    },
    emitConcatenatedPhone() {
      this.$emit('concatenated-phone', prefixes[this.selectedLanguage.langCode].prefix)
    },
    validate(event) {
      this.suggestActive = false
      this.$emit('validate', event)
      if (this.phoneNumber) {
        this.emitConcatenatedPhone()
      }
    },
    handleFocus() {
      if (this.isCrossClean) this.isFocused = true
    },
    focus(event) {
      if (event === 'keyup') {
        this.suggestActive = true
      }
      if (this.innerValue || this.suggestActive) {
        this.isFocused = true
      } else {
        this.isFocused = false
      }
    },
    focusDatepicker() {
      if (this.datepicker) this.isFocused = true
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectLanguage(language) {
      this.selectedLanguage = language
      if (this.phoneNumber) {
        this.emitConcatenatedPhone()
      }
      this.isOpen = false
    }
  }
}
